import { makeStyles } from '@mui/styles'

// Same label as the plain inputs on the store forms, so a dropdown lines up
// with the fields beside it.
const useStyles = makeStyles(theme => ({
  labelText: {
    textAlign: 'left',
    marginLeft: 0,
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.text.disabled,
    marginTop: '16px'
  }
}))

export default useStyles
